module.exports = __webpack_public_path__ + "media/images/crypto/1-c65316f7ee5c5f07116c113eff930f57.png";